var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helper-text-container",class:{ error: _vm.error }},[_c('div',{staticClass:"helper-icon"},[_c('HelpMessageIcon')],1),_c('label',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }